import styled from "styled-components";

// old background: #E5E5E8
const HomepageSC = styled.div`
    background-color: #F8EEF6;
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    scrollbar-width: none;
    ::-webkit-scrollbar {
        width: 0px;
        background: transparent;
    }

    .toolbar {
        height: 100px;
        width: 100%;
        align-items: center;
        display: flex;
        z-index: 4;
        position: absolute;

        .app-logo {
            height: 100%;
            margin-left: 24px;
        }
    }

    .app-footer {
        width: 100%;
        padding: 60px 20px;
        background: linear-gradient(180deg, #f8fbff 0%, #eef5ff 100%);
        display: flex;
        flex-direction: column;
        z-index: 2;
        align-items: center;
        margin-top: 100vh;
    }

    .app-container {
        max-width: 900px;
        text-align: center;
        font-family: Inter, system-ui, sans-serif;
        color: #5a6b85;
    }

    .app-logo {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        img {
            width: 350px;
            height: 250px;
            margin-top: -24px;
        }
    }

    .app-logo span {
        font-size: 18px;
        font-weight: 600;
        color: #1c2430;
    }

    .app-tagline {
        font-size: 16px;
        line-height: 1.6;
        max-width: 620px;
        margin-top: -24px;
    }

    .app-copy {
        font-size: 13px;
        margin-top: 36px;
        margin-bottom: 14px;
        color: #7a8aa3;
    }

    .app-links {
        display: flex;
        justify-content: center;
        gap: 22px;
        flex-wrap: wrap;
        margin-bottom: 18px;

        a {
            font-size: 13px;
            color: #6b7c99;
            text-decoration: none;
        }

        a:hover {
            color: #2b5cff;
        }
    }

    .app-love {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 6px;
        font-size: 13px;
        color: #6b7c99;

        span:first-child {
            color: #2b5cff;
            font-size: 15px;
        }
    }

    @media (max-width: 640px) {
        .app-footer {
            margin-top: 36px;
            order: 4
        }

        .toolbar {
            justify-content: center;
            .app-logo {
                margin-left: unset;
            }
        }
    }
`;

export default HomepageSC;